import React, { useState, useEffect } from 'react';

import {
  Box,
  Button,
  Container,
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  makeStyles
} from '@material-ui/core';

import Page from 'src/shared/ui/components/Page';
import PaymentDatatable from 'src/payment/ui/components/PaymentDatatable';

import downloadPaymentReceiptPdfById from 'src/payment-receipt/use-cases/downloadPaymentReceiptPdfById';
import downloadCreditNotePdfById from 'src/credit-note/use-cases/downloadCreditNotePdfById';
import downloadPaymentListExcel from 'src/payment/use-cases/downloadPaymentListExcel';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  button: {
    margin: theme.spacing(1)
  },
  buttonExportExcel: {
    left: '30px',
    top: '10px'
  }
}));

const PaymentListView = () => {
  const classes = useStyles();
  const companyHeadquarterId = localStorage.selectedUserHeadquarter;

  const [
    showSelectDownloadCreditNoteType,
    setShowSelectDownloadCreditNoteType
  ] = useState(false);

  const [
    selectedDownloadCreditNoteId,
    setSelectedDownloadCreditNoteId
  ] = useState(null);

  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const [exportExcelDialogVisible, setExportExcelDialogVisible] = useState(
    false
  );

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    const yearStart = new Date(Date.UTC(new Date().getUTCFullYear(), 0, 1))
      .toISOString()
      .split('T')[0];

    setFromDate(yearStart);
    setToDate(today);
  }, []);

  const handleDownload = (id, row) => {
    switch (row.PaymentType.code) {
      case 'CREDIT_NOTE':
        setSelectedDownloadCreditNoteId(id);
        setShowSelectDownloadCreditNoteType(true);
        break;
      default:
        setShowSelectDownloadCreditNoteType(false);
        downloadPaymentReceiptPdfById(id);
    }
  };

  const handleDownloadCreditNoteByType = (type) => {
    downloadCreditNotePdfById(selectedDownloadCreditNoteId, type);
    setShowSelectDownloadCreditNoteType(false);
  };

  const handleDialogCloseDownloadCreditNote = async (id) => {
    setShowSelectDownloadCreditNoteType(false);
  };

  const handleClickExportExcel = () => {
    setExportExcelDialogVisible(true);
  };

  const handleDialogCloseExport = async () => {
    setExportExcelDialogVisible(false);
  };

  const handleFromDateChange = (event) => {
    setFromDate(event.target.value);
  };

  const handleToDateChange = (event) => {
    setToDate(event.target.value);
  };

  const downloadExcel = (event) => {
    event.preventDefault();

    setExportExcelDialogVisible(false);

    downloadPaymentListExcel({
      companyHeadquarterId,
      fromDate,
      toDate
    });
  };

  return (
    <Page className={classes.root} title="Cobranzas">
      <Dialog
        onClose={handleDialogCloseDownloadCreditNote}
        aria-labelledby="simple-dialog-title"
        open={showSelectDownloadCreditNoteType}
      >
        <DialogTitle id="simple-dialog-title">
          Seleccione el tipo de nota de crédito
        </DialogTitle>
        <List>
          <ListItem
            button
            onClick={() =>
              handleDownloadCreditNoteByType('ORIGINAL_AND_DUPLICATE')
            }
            key={'ORIGINAL_AND_DUPLICATE'}
          >
            <ListItemText primary={'Original'} />
          </ListItem>
          <ListItem
            button
            onClick={() => handleDownloadCreditNoteByType('CUSTOMER')}
            key={'CUSTOMER'}
          >
            <ListItemText primary={'Digital'} />
          </ListItem>
        </List>
      </Dialog>

      <Dialog
        onClose={handleDialogCloseExport}
        aria-labelledby="simple-dialog-title"
        open={exportExcelDialogVisible}
      >
        <DialogTitle id="export-excel-dialog">
          Seleccione el intervalo
        </DialogTitle>
        <List>
          <ListItem>Desde</ListItem>
          <ListItem>
            <input
              type="date"
              id="from-date"
              name="fromDate"
              value={fromDate}
              onChange={handleFromDateChange}
            />
          </ListItem>
          <ListItem>Hasta</ListItem>
          <ListItem>
            <input
              type="date"
              id="to-date"
              name="toDate"
              value={toDate}
              onChange={handleToDateChange}
            />
          </ListItem>
          <ListItem key={'DOWNLOAD'}>
            <Button
              className={classes.buttonExportExcel}
              color="primary"
              variant="contained"
              onClick={downloadExcel}
            >
              Exportar
            </Button>
          </ListItem>
        </List>
      </Dialog>

      <Container maxWidth={false}>
        <PaymentDatatable
          handleDownload={handleDownload}
          handleClickExportExcel={handleClickExportExcel}
          showAddButton={true}
        />
      </Container>
    </Page>
  );
};

export default PaymentListView;
